






























































































































































































































































































































































import Vue, { PropType } from 'vue';
import { adminRepository, eventRepository } from '@/api';
import AppAlerts from '@/components/molecules/appAlerts/AppAlerts.vue';
import Icon from '@/components/atoms/icon/Icon.vue';
import SpinnerArea from '@/components/molecules/spinnerArea/SpinnerArea.vue';
import AppButton from '@/components/atoms/appButton/AppButton.vue';
import AppContent from '@/components/atoms/appContent/AppContent.vue';
import AppLayer from '@/components/molecules/appLayer/AppLayer.vue';
import AppScrollbar from '@/components/atoms/appScrollbar/AppScrollbar.vue';
import { MessageType } from '@/enums/messageType';
import { alertService } from '@/services/alertService';
import type { Application } from '@/api/interfaces/application/application';
import { SpinnerState } from '@/enums/spinnerState';
import { Address } from '@/api/interfaces/application/address';
import { camelCase, debounce as _debounce, DebouncedFunc } from 'lodash';
import { AdminGridContent } from '@/api/interfaces/content/app/adminGridContent';
import { EntryListContent } from '@/api/interfaces/content/common/entryListContent';
import { ConfirmationLayerContent } from '@/api/interfaces/content/common/confirmationLayerContent';
import { ServiceError } from '@/api/interfaces/serviceError';
import { downloadFile } from '@/services/fileDownloadService';
import { AdminDocumentId } from '@/api/interfaces/admin/adminDocumentId';
import { Pagination } from '@/api/interfaces/common/pagination';
import { AdminUpdateDataModel } from '@/types/app/admin/adminUpdateDataModel';
import AdminPagination from '@/components/organisms/adminPagination/AdminPagination.vue';
import FormBooleanCheckbox from '@/components/molecules/formBooleanCheckbox/FormBooleanCheckbox.vue';
import { isServiceError } from '@/api/interfaces/typeGuards';
import { CheckboxField } from '@/types/forms/fields/checkboxField';
import FormField from '@/components/molecules/formField/FormField.vue';
import { TextField } from '@/types/forms/fields/textField';
import FormInputText from '@/components/atoms/formInputText/FormInputText.vue';
import { staticStringTemplateLiterals } from '@/utilities/utils';
import { DateRange } from '@/types/forms/shared/dateRange';
import EventModal from '@/components/molecules/eventModal/EventModal.vue';
import { Event } from '@/api/interfaces/event/event';
import { ApplicationStatus } from '@/enums/applicationStatus';
import { DeaDbApiStatusPart } from '@/api/interfaces/external/deaDbApi/deaDbApiStatusPart';
import { SaaApiStatusPart } from '@/api/interfaces/external/saaApi/saaApiStatusPart';

interface GridColumn {
    key: string;
}

type DeaDbApiStatus = DeaDbApiStatusPart['status'];
type SaaApiStatus = SaaApiStatusPart['status'];
type ApiIndicator = 'neutral' | 'success' | 'warning' | 'error';

const apiMaxRetries = 3;

const gridColumns: GridColumn[] = [
    { key: 'applicantId' },
    { key: 'applicationId' },
    { key: 'api' },
    { key: 'status' },
    { key: 'dataVersion' },
    { key: 'applicationNumber' },
    { key: 'created' },
    { key: 'submitted' },
    { key: 'completed' },
];

export default Vue.extend({
    name: 'AdminGrid',
    components: {
        AppAlerts,
        AppButton,
        AppContent,
        AppLayer,
        AppScrollbar,
        Icon,
        SpinnerArea,
        AdminPagination,
        FormField,
        FormBooleanCheckbox,
        FormInputText,
        EventModal,
    },
    props: {
        entries: {
            type: Array as PropType<Application[]>,
            default: () => [],
        },
        pagination: {
            type: Object as PropType<Pagination>,
            required: true,
        },
        nextApiDispatchAt: {
            type: String,
            default: null,
        },
        content: {
            type: Object as PropType<AdminGridContent>,
            required: true,
        },
        deleteApplicationConfirmationLayerContent: {
            type: Object as PropType<ConfirmationLayerContent>,
            required: true,
        },
        migrateApplicantLayerContent: {
            type: Object as PropType<ConfirmationLayerContent>,
            required: true,
        },
        exportLayerContent: {
            type: Object as PropType<ConfirmationLayerContent>,
            required: true,
        },
        apiActionsLayerContent: {
            type: Object as PropType<ConfirmationLayerContent>,
            required: true,
        },
        enumsContent: {
            type: Object as PropType<EntryListContent>,
            required: true,
        },
        applicationStatusItems: {
            type: Object,
            default: null,
        },
        gridSpinner: {
            type: String as PropType<SpinnerState>,
            required: true,
        },
        adminUpdateData: {
            type: Object as PropType<AdminUpdateDataModel>,
            default: new AdminUpdateDataModel(),
        },
    },
    data() {
        return {
            spinner: SpinnerState.off,
            alertService,
            alert: '',
            type: '',
            gridColumns: gridColumns,
            applicationIdToDelete: null as string | null,
            migrateApplicantTargetApplicantId: {
                value: null as string | null,
            } as TextField,
            migrateApplicantApplicationIds: null as string[] | null,
            internalAdminUpdateData: this.adminUpdateData,
            applyMigrationsModel: new CheckboxField({
                value: true,
            }),
            updateDataDebounce: null as null | DebouncedFunc<() => void>,
            showExportLayer: false,
            apiActionsApplicationIds: null as string[] | null,
            includeDeaDbApiActionsModel: new CheckboxField({
                value: true,
            }),
            includeSaaApiActionsModel: new CheckboxField({
                value: true,
            }),
            showEventModal: false,
            currentEvents: [] as Event[],
            currentApplicationId: '',
        };
    },
    computed: {
        spinnerState(): SpinnerState {
            return this.gridSpinner == SpinnerState.off
                ? this.spinner
                : this.gridSpinner;
        },
        hasApplications(): boolean {
            return this.entries.length > 0;
        },
        migrateApplicantLayerConfirmationText(): string {
            return staticStringTemplateLiterals(
                this.migrateApplicantLayerContent.confirmationText,
                {
                    migrateApplicantApplicationIds: this
                        .migrateApplicantApplicationIds,
                },
            );
        },
        exportLayerConfirmationText(): string {
            return staticStringTemplateLiterals(
                this.exportLayerContent.confirmationText,
                {
                    paginationTotal: this.pagination?.total,
                },
            );
        },
        apiActionsLayerConfirmationText(): string {
            return staticStringTemplateLiterals(
                this.apiActionsLayerContent.confirmationText,
                {
                    paginationTotal: this.pagination?.total,
                    apiActionsApplicationCount: this.apiActionsApplicationCount,
                    apiActionsApplicationListHtml: this
                        .apiActionsApplicationListHtml,
                },
            );
        },
        apiActionsApplicationCount(): number {
            return this.apiActionsApplicationIds?.length ?? 0;
        },
        apiActionsApplicationListHtml(): string {
            return this.entries
                .filter((entry) =>
                    this.apiActionsApplicationIds?.includes(
                        entry.applicationId,
                    ),
                )
                .map((entry) => {
                    const labels = [
                        this.entryHasDeaDbApiErrors(entry)
                            ? '<span title="' +
                              this.entryApiTitle(entry) +
                              '">DEA</span>'
                            : '',
                        this.entryHasSaaApiErrors(entry)
                            ? '<span title="' +
                              this.entryApiTitle(entry) +
                              '">SAA</span>'
                            : '',
                    ]
                        .filter(Boolean)
                        .join(' ');

                    return `<li>${entry.applicationId} ${labels}</li>`;
                })
                .join('');
        },
    },
    methods: {
        entryHasDeaDbApiErrors(entry: Application): boolean {
            return (
                entry.deaDbApiStatus.applicationSent.status === 'Failed' ||
                entry.deaDbApiStatus.applicationDeleted.status === 'Failed'
            );
        },
        entryHasSaaApiProblems(entry: Application): boolean {
            return (
                entry.saaApiStatus.applicationSent.status === 'Pending' ||
                entry.saaApiStatus.applicationSent.status === 'Failed' ||
                entry.saaApiStatus.applicationStatusChanged.status ===
                    'Pending' ||
                entry.saaApiStatus.applicationStatusChanged.status === 'Failed'
            );
        },
        entryHasSaaApiErrors(entry: Application): boolean {
            return (
                entry.saaApiStatus.applicationSent.status === 'Failed' ||
                entry.saaApiStatus.applicationStatusChanged.status === 'Failed'
            );
        },
        entryHasApiErrors(entry: Application): boolean {
            return (
                this.entryHasDeaDbApiErrors(entry) ||
                this.entryHasSaaApiErrors(entry)
            );
        },
        entryHasApiWarnings(entry: Application): boolean {
            if (this.entryHasApiErrors(entry)) {
                return false;
            }
            const notSentViaApiYet =
                entry.deaDbApiStatus.applicationSent.status === 'Pending' ||
                entry.deaDbApiStatus.applicationSent.status === 'Failed';
            const notDeletedViaApiYet =
                entry.deaDbApiStatus.applicationDeleted.status === 'Pending' ||
                entry.deaDbApiStatus.applicationDeleted.status === 'Failed';
            return (
                (entry.status === ApplicationStatus.deleted &&
                    notSentViaApiYet) ||
                notDeletedViaApiYet ||
                (entry.status !== ApplicationStatus.draft &&
                    entry.deaDbApiStatus.applicationSent.status === 'Pending')
            );
        },
        getDeaApiStatus(entry: Application): DeaDbApiStatus {
            return this.aggregateApiStatus([
                entry.deaDbApiStatus.applicationSent.status,
                entry.deaDbApiStatus.applicationDeleted.status,
                entry.deaDbApiStatus.applicationConfirmation.status,
                entry.deaDbApiStatus.applicationCommitment.status,
            ]);
        },
        getDeaApiAttempts(entry: Application): number {
            return Math.max(
                entry.deaDbApiStatus.applicationSent.attempts,
                entry.deaDbApiStatus.applicationDeleted.attempts,
                entry.deaDbApiStatus.applicationConfirmation.attempts,
                entry.deaDbApiStatus.applicationCommitment.attempts,
            );
        },
        getSaaApiStatus(entry: Application): SaaApiStatus {
            return this.aggregateApiStatus([
                entry.saaApiStatus.applicationSent.status,
                entry.saaApiStatus.applicationStatusChanged.status,
            ]);
        },
        getSaaApiAttempts(entry: Application): number {
            return Math.max(
                entry.saaApiStatus.applicationSent.attempts,
                entry.saaApiStatus.applicationStatusChanged.attempts,
            );
        },
        getDeaApiIndicator(status: DeaDbApiStatus, attempts = 0): ApiIndicator {
            if (status === 'Success') {
                return 'success';
            }
            if (status === 'Pending' || status === 'Failed') {
                return attempts >= apiMaxRetries ? 'error' : 'warning';
            }
            return 'neutral';
        },
        getSaaApiIndicator(status: SaaApiStatus, attempts = 0): ApiIndicator {
            if (status === 'Success') {
                return 'success';
            }
            if (status === 'Pending' || status === 'Failed') {
                return attempts >= apiMaxRetries ? 'error' : 'warning';
            }
            return 'neutral';
        },
        apiIndicatorClass(indicator: ApiIndicator): string {
            switch (indicator) {
                case 'success':
                    return 'text-success';
                case 'warning':
                    return 'text-warning';
                case 'error':
                    return 'text-error';
                default:
                    return 'text-tertiary';
            }
        },
        entryOutlineClass(entry: Application): string {
            const deaIndicator = this.getDeaApiIndicator(
                this.getDeaApiStatus(entry),
                this.getDeaApiAttempts(entry),
            );
            const saaIndicator = this.getSaaApiIndicator(
                this.getSaaApiStatus(entry),
                this.getSaaApiAttempts(entry),
            );
            const finalFailureCount = [deaIndicator, saaIndicator].filter(
                (indicator) => indicator === 'error',
            ).length;

            if (finalFailureCount === 2) {
                return 'outline-error';
            }
            if (finalFailureCount === 1) {
                return 'outline-saa-api';
            }
            if (deaIndicator === 'warning' || saaIndicator === 'warning') {
                return 'outline-warning';
            }
            return '';
        },
        aggregateApiStatus(statuses: DeaDbApiStatus[]): DeaDbApiStatus {
            if (statuses.includes('Failed')) {
                return 'Failed';
            }
            if (statuses.includes('Pending')) {
                return 'Pending';
            }
            if (statuses.includes('Success')) {
                return 'Success';
            }
            return 'Ignored';
        },
        formatDeaDbApiStatusPart(
            name: string,
            status: DeaDbApiStatus,
            attempts: number,
        ): string {
            return `${name}: ${status} (${attempts}x)`;
        },
        formatSaaApiStatusPart(
            name: string,
            status: SaaApiStatus,
            attempts: number,
        ): string {
            return `${name}: ${status} (${attempts}x)`;
        },
        entryApiTitle(entry: Application): string {
            return [
                this.formatDeaDbApiStatusPart(
                    'DEA ApplicationSent',
                    entry.deaDbApiStatus.applicationSent.status,
                    entry.deaDbApiStatus.applicationSent.attempts,
                ),
                this.formatDeaDbApiStatusPart(
                    'DEA ApplicationDeleted',
                    entry.deaDbApiStatus.applicationDeleted.status,
                    entry.deaDbApiStatus.applicationDeleted.attempts,
                ),
                this.formatDeaDbApiStatusPart(
                    'DEA ApplicationConfirmation',
                    entry.deaDbApiStatus.applicationConfirmation.status,
                    entry.deaDbApiStatus.applicationConfirmation.attempts,
                ),
                this.formatDeaDbApiStatusPart(
                    'DEA ApplicationCommitment',
                    entry.deaDbApiStatus.applicationCommitment.status,
                    entry.deaDbApiStatus.applicationCommitment.attempts,
                ),
                this.formatSaaApiStatusPart(
                    'SAA ApplicationSent',
                    entry.saaApiStatus.applicationSent.status,
                    entry.saaApiStatus.applicationSent.attempts,
                ),
                this.formatSaaApiStatusPart(
                    'SAA ApplicationStatusChanged',
                    entry.saaApiStatus.applicationStatusChanged.status,
                    entry.saaApiStatus.applicationStatusChanged.attempts,
                ),
            ].join('\n');
        },
        camelCase,
        renderApplicationAddress(address: Address): string {
            const streetAndHousenumber = `${address.street ?? ''} ${
                address.houseNumber ?? ''
            }`.trim();
            const meadowAndLot = `${address.meadow ?? ''} ${
                address.lot ?? ''
            }`.trim();
            const subdistrictAndMeadowAndLot = `${
                address.subdistrict ?? ''
            } ${meadowAndLot}`.trim();
            return `${address.postCode} ${address.city}<br />${streetAndHousenumber} ${subdistrictAndMeadowAndLot}`.trim();
        },
        getIconId(lookup: string): string | null {
            switch (lookup) {
                case 'Photovoltaics':
                    return 'Solarenergie-filled';
                case 'PowerPlant':
                    return 'Erzeugung-filled';
                case 'ThermalPower':
                    return 'Windenergie-filled';
                default:
                    return null;
            }
        },
        prepareDeletingApplication(applicationId: string): void {
            this.applicationIdToDelete = applicationId;
        },
        cancelDeletingApplication(): void {
            this.applicationIdToDelete = null;
        },
        deleteApplication(): void {
            if (!this.applicationIdToDelete) {
                return;
            }

            const applicationId = this.applicationIdToDelete;
            this.applicationIdToDelete = null;

            adminRepository
                .deleteApplication(applicationId)
                .then(() => {
                    alertService.pushAlert({
                        alert: {
                            type: MessageType.info,
                            identifier: 'applications.deleted',
                        },
                    });

                    this.$emit('delete-application', applicationId);
                })
                .catch((error: ServiceError) => {
                    if (isServiceError(error)) {
                        alertService.pushAlert({
                            alert: {
                                type: MessageType.error,
                                identifier: error.messageCode,
                            },
                        });
                    }
                })
                .finally(() => {
                    this.spinner = SpinnerState.off;
                });
        },
        async download(
            documentId: AdminDocumentId,
            applicationId: string,
            jsonDataOnly?: boolean,
        ): Promise<void> {
            this.spinner = SpinnerState.transparent;

            adminRepository
                .downloadDocument(
                    documentId,
                    applicationId,
                    this.applyMigrationsModel.value ?? undefined,
                    jsonDataOnly,
                )
                .then((response) => {
                    downloadFile(response.bytes, response.fileName);
                })
                .catch((error: ServiceError) => {
                    if (isServiceError(error)) {
                        alertService.pushAlert({
                            alert: {
                                type: MessageType.error,
                                identifier: error.messageCode,
                            },
                        });
                    }
                })
                .finally(() => {
                    this.spinner = SpinnerState.off;
                });
        },
        async downloadZip(applicationId: string): Promise<void> {
            return this.download('zip', applicationId);
        },
        async downloadCsv(applicationId: string): Promise<void> {
            return this.download('csv', applicationId);
        },
        async downloadJson(
            applicationId: string,
            dataOnly: boolean,
        ): Promise<void> {
            return this.download('json', applicationId, dataOnly);
        },
        handlePageChanged(page: number): void {
            this.internalAdminUpdateData.offset =
                (page - 1) * this.internalAdminUpdateData.limit;
            this.updateData();
        },
        handleQueryChanged(query: string, updateData = true): void {
            this.internalAdminUpdateData.offset = 0;
            this.internalAdminUpdateData.query = query;
            if (updateData) {
                this.updateData();
            }
        },
        handleDateSentAtChanged(
            dateSentAt: DateRange,
            updateData = true,
        ): void {
            this.internalAdminUpdateData.dateSentAtStart = dateSentAt?.start;
            this.internalAdminUpdateData.dateSentAtEnd = dateSentAt?.end;
            if (updateData) {
                this.updateData();
            }
        },
        handleStatusesChanged(statuses: string[], updateData = true): void {
            this.internalAdminUpdateData.statuses = statuses;
            if (updateData) {
                this.updateData();
            }
        },
        handleApiProblemsChanged(active: boolean): void {
            this.internalAdminUpdateData.offset = 0;
            this.internalAdminUpdateData.apiProblemsOnly = active;
            this.updateData();
        },
        handleFilterReset(): void {
            this.internalAdminUpdateData.apiProblemsOnly = false;
            this.handleQueryChanged('', false);
            this.handleDateSentAtChanged({ start: '', end: '' }, false);
            this.handleStatusesChanged([], false);
            this.updateData();
        },
        updateData(): void {
            this.spinner = SpinnerState.transparent;

            if (this.updateDataDebounce) {
                this.updateDataDebounce.cancel();
            }

            this.updateDataDebounce = _debounce(() => {
                this.$emit('update-applications', this.internalAdminUpdateData);
                this.spinner = SpinnerState.off;
            }, 500);

            this.updateDataDebounce();
        },
        prepareMigratingApplicant(): void {
            this.migrateApplicantApplicationIds = this.entries.map(
                (e) => e.applicationId,
            );
        },
        migrateApplicant(): void {
            if (
                !this.migrateApplicantApplicationIds ||
                !this.migrateApplicantApplicationIds.length ||
                !this.migrateApplicantTargetApplicantId.value
            ) {
                alertService.pushAlert({
                    alert: {
                        type: MessageType.error,
                        identifier:
                            'admin.migrateApplicantRequirementsUnfulfilled',
                    },
                });
                return;
            }

            const applicationIds = this.migrateApplicantApplicationIds;
            const targetApplicantId = this.migrateApplicantTargetApplicantId
                .value;
            this.migrateApplicantApplicationIds = null;
            this.migrateApplicantTargetApplicantId.value = null;
            this.spinner = SpinnerState.transparent;

            adminRepository
                .migrateApplicant(applicationIds, targetApplicantId)
                .then(() => {
                    alertService.pushAlert({
                        alert: {
                            type: MessageType.info,
                            identifier: 'admin.migrateApplicantSuccess',
                        },
                    });

                    this.updateData();
                })
                .catch((error: ServiceError) => {
                    if (isServiceError(error)) {
                        alertService.pushAlert({
                            alert: {
                                type: MessageType.error,
                                identifier: error.messageCode,
                            },
                        });
                    }
                })
                .finally(() => {
                    this.spinner = SpinnerState.off;
                });
        },
        cancelMigratingApplicant(): void {
            this.migrateApplicantApplicationIds = null;
            this.migrateApplicantTargetApplicantId.value = null;
        },
        prepareExportingApplications(): void {
            this.showExportLayer = true;
        },
        async exportApplications(): Promise<void> {
            this.spinner = SpinnerState.transparent;

            adminRepository
                .export('csv', this.adminUpdateData)
                .then((response) => {
                    downloadFile(response.bytes, response.fileName);
                })
                .catch((error: ServiceError) => {
                    if (isServiceError(error)) {
                        alertService.pushAlert({
                            alert: {
                                type: MessageType.error,
                                identifier: error.messageCode,
                            },
                        });
                    }
                })
                .finally(() => {
                    this.showExportLayer = false;
                    this.spinner = SpinnerState.off;
                });
        },
        cancelExportingApplications(): void {
            this.showExportLayer = false;
        },
        prepareApiActions(): void {
            this.apiActionsApplicationIds = this.entries
                .filter((entry) => this.entryHasApiErrors(entry))
                .map((e) => e.applicationId);
            this.includeDeaDbApiActionsModel.value = true;
            this.includeSaaApiActionsModel.value = true;
        },
        cancelApiActions(): void {
            this.apiActionsApplicationIds = null;
        },
        async executeApiActions(): Promise<void> {
            if (
                !this.apiActionsApplicationIds ||
                !this.apiActionsApplicationIds.length ||
                (!this.includeDeaDbApiActionsModel.value &&
                    !this.includeSaaApiActionsModel.value)
            ) {
                alertService.pushAlert({
                    alert: {
                        type: MessageType.error,
                        identifier: 'admin.apiActionsRequirementsUnfulfilled',
                    },
                });
                return;
            }

            const applicationIds = this.apiActionsApplicationIds;
            this.apiActionsApplicationIds = null;
            this.spinner = SpinnerState.transparent;

            adminRepository
                .executeApiActions(
                    applicationIds,
                    this.includeDeaDbApiActionsModel.value === true,
                    this.includeSaaApiActionsModel.value === true,
                )
                .then(() => {
                    alertService.pushAlert({
                        alert: {
                            type: MessageType.info,
                            identifier: 'admin.apiActionsSuccess',
                        },
                    });

                    this.updateData();
                })
                .catch((error: ServiceError) => {
                    if (isServiceError(error)) {
                        alertService.pushAlert({
                            alert: {
                                type: MessageType.error,
                                identifier: error.messageCode,
                            },
                        });
                    }
                })
                .finally(() => {
                    this.spinner = SpinnerState.off;
                });
        },
        async showEvents(applicationId: string): Promise<void> {
            this.spinner = SpinnerState.transparent;
            this.currentApplicationId = applicationId;
            try {
                const events = await eventRepository.getEvents(applicationId);
                if (Array.isArray(events)) {
                    this.currentEvents = events;
                    this.showEventModal = true;
                } else {
                    throw new Error('Invalid response format');
                }
            } catch (error) {
                console.error('Error fetching events:', error);
                alertService.pushAlert({
                    alert: {
                        type: MessageType.error,
                        identifier: isServiceError(error)
                            ? error.messageCode
                            : 'events.fetchError',
                    },
                });
            } finally {
                this.spinner = SpinnerState.off;
            }
        },
        closeEventModal(): void {
            this.showEventModal = false;
            this.currentEvents = [];
        },
    },
});
